import React, { useEffect } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import UserManagementTable from "../../../components/Admin/UserManagement/UserManagementTable/UserManagementTable";
import { userManagement } from "../../../utils/mainTabs/admin/userManagement/userManagement";
import { userManagementForm } from "../../../utils/mainTabs/admin/userManagement/userManagementForm";
import { tileSize } from "../../../utils/tileSizes";
import { tileTypes } from "../../../utils/tileTypes";

const UserManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const {
    tenantName,
    setAdminNavLinks,
    setAdminButtons,
    setAdminTiles,
    setAdminTilesType,
    setAdminTilesSize,
    setIsAdminStepTiles,
  } = useOutletContext();

  const { path: userManagePath, navLinks: userManageNavLinks } = userManagement;
  const userManagementPath = userManagePath(tenantName);
  const {
    path: userManageFormPath,
    navLinks: userManageFormNavLinks,
    tiles: userManageFormTiles,
  } = userManagementForm;
  const userManagementFormPath = userManageFormPath(
    location,
    tenantName,
    params?.userId
  );

  useEffect(() => {
    if (location.pathname === userManagementPath) {
      const userManagementNavLinks = userManageNavLinks(navigate, tenantName);
      setAdminTiles([]);
      setAdminNavLinks(userManagementNavLinks);
      setAdminButtons([]);
    } else if (location.pathname.includes(userManagementFormPath)) {
      const userManagementFormNavLinks = userManageFormNavLinks(
        navigate,
        location,
        tenantName,
        params?.userId
      );
      const userManagementFormTiles = userManageFormTiles(
        navigate,
        location,
        tenantName,
        params?.userId
      );
      setAdminTiles(userManagementFormTiles);
      setAdminTilesType(tileTypes.DEFAULT);
      setAdminTilesSize(tileSize.LARGE);
      setIsAdminStepTiles(true);
      setAdminNavLinks(userManagementFormNavLinks);
      setAdminButtons([]);
    }
  }, [
    location.pathname,
    setAdminButtons,
    setAdminNavLinks,
    setAdminTiles,
    setAdminTilesSize,
    setAdminTilesType,
    setIsAdminStepTiles,
    userManagementFormPath,
    userManagementPath,
    location,
    navigate,
    params?.userId,
    tenantName,
    userManageFormNavLinks,
    userManageFormTiles,
    userManageNavLinks,
  ]);

  return location.pathname === userManagementPath ? (
    <UserManagementTable />
  ) : (
    <Outlet context={{ tenantName }} />
  );
};

export default UserManagement;
